<template>
    <div class="message max-content">
		<div class="item " @click="goSystemMessage">
			<div class="picture">
        		<img src="../../../assets/images/System/system_message.png">
			</div>
			<div class="system-text">
				<span class="title">系统消息<van-icon v-if="has_read_system" name="" dot /></span>
				<span class="content">{{firstSystemMessage}}</span>
			</div>
		</div>
		<div class="item" @click="goDateMessage">
			<div class="picture">
        		<img src="../../../assets/images/System/date_message.png">
			</div>
			<div class="date-text">
				<span class="title">日程消息<van-icon v-if="has_read_date"  name="" dot /></span>
				<span class="content">{{firstDateMessage}}</span>
			</div>
		</div>
        <tabbar :active="index"></tabbar>
    </div>
</template>
<script>
	import ItemBlock from '../components/ItemBlock'
	import Tabbar from '../components/Tabbar'
	import {SystemNotice,MeetingMessage,PersoanalUserInfo,HasRead} from '../../../config/interface.js'
	export default{
		components:{
			ItemBlock,
			Tabbar
		},
		data(){
			return{
				index:3,
				userInfo:this.$store.state.userInfo,  //用户信息
				firstSystemMessage:'',
				firstDateMessage:'',
				has_read_system:0,
				has_read_date:0
			}
		},
		mounted(){
			// if(this.userInfo&&!common.is_weixin()){
			// 	this.init();
			// }
			// if(this.userInfo&&common.is_weixin()){
			// 	this.getUserInfo();
			// }
			if(this.userInfo){
				this.init();
			}
		},
		methods:{
			init(){
				this.getSystemMessage();
				this.getDateMessage();
				this.hasNoRead();

			},
			//得到用户信息
            getUserInfo(){
                const url=PersoanalUserInfo;
                let params={};
                const method='POST';
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        let data=res.data;
                        localStorage.setItem('userInfo',JSON.stringify(data));
                        this.$store.dispatch('storageUserInfo',data);	
                        this.userInfo=data;
                        if(this.userInfo&&this.userInfo.mobile_status==1){
							this.init();
                        }
                        else{
                            common.toast('未绑定手机',1000,'fail',()=>{
                                 this.$router.replace({
                                    path:'/vascularNews/user/login',
                                    query:{url:window.location.href}
                            })
					        })	
                        }
                    }
                })
            },
			hasNoRead(){
				const url=HasRead;
				const method='POST'
				let params={};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						if(data.system_read==0){
							this.has_read_system=1;
						}
						if(data.meeting_read==0){
							this.has_read_date=1;
						}
					}
				})
			},
			getSystemMessage(){
				const url=SystemNotice;
				const method='POST'
				let params={};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data.data;
						if(data.length>0){
							if(data[0].title.length<25)
							{
								this.firstSystemMessage=data[0].title
							}
							else{
								this.firstSystemMessage=data[0].title.slice(0,25)+"..."
							}
						}
					}
				})
			},
			getDateMessage(){
				const url=MeetingMessage;
				const method='POST'
				let params={};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						if(data.length>0){
							if(data[0].title.length<25){
								this.firstDateMessage=data[0].title
							}
							else{
								this.firstDateMessage=data[0].title.slice(0,25)+"..."
							}
						}
					}
				})

			},
			goSystemMessage(){
				if(this.userInfo){
					this.$router.push({
					path:'/vascularNews/message/system'
				})	
				}	
				else{
					this.$dialog.confirm({
                    	message: '您尚未登录，确定去登陆？',
                    }).then(() => {
						this.$router.push({
						path:'/vascularNews/user/login',
						query:{
							url:window.location.href
						}
					})	

					}).catch({})
				}
			},
			goDateMessage(){
				if(this.userInfo){
					this.$router.push({
					path:'/vascularNews/message/date',
				})
				}
				else{
					this.$dialog.confirm({
                    	message: '您尚未登录，确定去登陆？',
                    }).then(() => {
						this.$router.push({
						path:'/vascularNews/user/login',
						query:{
							url:window.location.href
						}
					})	
					}).catch({})
				}	
			}
			
		}
		
	}
</script>
<style lang="scss">
.message{
	margin-bottom: 50px;
	background: white;
	.item{
		display: flex;
		height:80px;
		.picture{
			width:18%;
			margin-top:20px;
			img{
				width:45px;
				height:45px;
				display: block;
				margin: 0 auto;
			}
		}
		.system-text{
			margin-top:20px;
			width:82%;
			border-bottom:1px solid rgb(243, 240, 240) ;
			.title{
				font-size:14px;
				line-height: 16px;
				.van-info{
					position: relative;
					top:0;
				}
				
			}
			.content{
				display: block;
				margin-top:8px;
				color: rgb(170, 163, 163);
			}
		}
		.date-text{
			margin-top:20px;
			width:80%;
			.title{
				font-size:14px;
				line-height: 16px;
				.van-info{
					position: relative;
					top:0;
				}
			}
			.content{
				display: block;
				margin-top:8px;
				font-size:12px ;
				color: rgb(170, 163, 163);
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Message/Index.vue